export const mapPAPIChannelCode = (channel: string) => {
  // Remove DD & RO prefix as it's internal use only
  return channel.replace(/DD_|DP_/, "");
};
